import { SolicitationFilterDashboard } from "../../models/SolicitationFilter";
import APIClient from "../api";

export default class DashboardFilterService extends APIClient {
    constructor(props: any) {
        super(props);
    }

    async getDashboardByFilter(solicitationFilter: SolicitationFilterDashboard ) {
        const url = `${this.endpoint}/DashboardFilter/ByFilter`;

        return this.api ({
            method: 'post',
            data: solicitationFilter,
            url
        })
    }

    async getDashboardListByFilter(solicitationFilter: SolicitationFilterDashboard ) {
        const url = `${this.endpoint}/DashboardFilter/ListByFilter`;

        return this.api ({
            method: 'post',
            data: solicitationFilter,
            url
        })
    }

    async getDashboardSurveyAnswseredMonth(solicitationFilter: SolicitationFilterDashboard ) {
        const url = `${this.endpoint}/DashboardFilter/SurveyAnswseredMonth`;

        return this.api ({
            method: 'post',
            data: solicitationFilter,
            url
        })
    }
    async getDashboardSurveyCreatedMonth(solicitationFilter: SolicitationFilterDashboard ) {
        const url = `${this.endpoint}/DashboardFilter/SurveyCreatedMonth`;

        return this.api ({
            method: 'post',
            data: solicitationFilter,
            url
        })
    }

    async getDashboardListByTop10(solicitationFilter: SolicitationFilterDashboard) {
        const url = `${this.endpoint}/DashboardFilter/ListByTop10`

        return this.api({
            method: 'post',
            data: solicitationFilter,
            url
        })
    }







    












    async GetBIWorkListByFilterAll(solicitationFilter: SolicitationFilterDashboard) {
        // const url = `https://localhost:32768/HeyhoDashboardApi/api/BiWork/GetBIWorkList/ByFilterAll`;
        const url = `${this.endpointDash}/api/BiWork/GetBIWorkList/ByFilterAll`;

        return this.api({
            method: 'post',
            data: solicitationFilter,
            url
        });
    }

    async GetBIWorkListListByFilter(solicitationFilter: SolicitationFilterDashboard ) {
        // const url = `https://localhost:49163/HeyhoDashboardApi/api/BiWork/GetBIWorkList/ListByFilter`;
        const url = `${this.endpointDash}/api/BiWork/GetBIWorkList/ListByFilter`;

        return this.api ({
            method: 'post',
            data: solicitationFilter,
            url
        })
    }
}